<template>
  <div>
    <template v-if="type === '数值型'">
      <el-input
        v-model="list[index].new_parameter_value"
        class="inputItem"
        type="number"
        size="mini"
        :disabled="isDisabled"
        style="width: 100%"
        :placeholder="'请输入' + list[index].new_parameter_name"
      ></el-input>
    </template>
    <!--  -->
    <template v-if="type === '文本型'">
      <el-input
        v-model="list[index].new_parameter_value"
        class="inputItem"
        style="width: 100%"
        size="mini"
        :disabled="isDisabled"
        @input="list[index].new_parameter_value"
        :placeholder="'请输入' + list[index].new_parameter_name"
      ></el-input>
    </template>
    <!--  -->
    <template
      v-if="
        type === '选项型' && list[index].new_parameter_select_type == '单选'
      "
    >
      <el-select
        v-model="list[index].new_parameter_value"
        placeholder="请选择"
        size="mini"
        :disabled="isDisabled"
      >
        <el-option
          v-for="(item, index) in list[index].new_parameter_layer_item_list"
          :key="index"
          :label="item.code_desc"
          :value="item.code"
        >
        </el-option>
      </el-select>
    </template>
    <!--  -->
    <template
      v-if="
        type === '选项型' && list[index].new_parameter_select_type == '多选'
      "
    >
      <el-select
        v-model="list[index].new_parameter_value_list"
        multiple
        size="mini"
        placeholder="请选择"
        :disabled="isDisabled"
      >
        <el-option
          v-for="(item, index) in list[index].new_parameter_layer_item_list"
          :key="index"
          :label="item.code_desc"
          :value="item.code"
        >
        </el-option>
      </el-select>
    </template>
    <!--  -->
    <template
      v-if="
        (type === '日期型' &&
          list[index].new_parameter_time_type == '年月日时分秒') ||
        list[index].new_parameter_time_type == '年月日 时分秒'
      "
    >
      <el-date-picker
        v-model="list[index].new_parameter_value"
        type="datetime"
        size="mini"
        :disabled="isDisabled"
        value-format="yyyy-MM-dd HH:mm:ss"
        style="width: 100%"
        placeholder="选择日期时间"
        align="right"
        :picker-options="pickerOptions"
      >
      </el-date-picker>
    </template>
    <template
      v-if="
        (type === '日期型' &&
          list[index].new_parameter_time_type == '年月日时分') ||
        list[index].new_parameter_time_type == '年月日 时分'
      "
    >
      <el-date-picker
        v-model="list[index].new_parameter_value"
        type="datetime"
        size="mini"
        :disabled="isDisabled"
        value-format="yyyy-MM-dd HH:mm"
        format="yyyy-MM-dd HH:mm"
        style="width: 100%"
        placeholder="选择日期时间"
        align="right"
        :picker-options="pickerOptions"
      >
      </el-date-picker>
    </template>
    <template
      v-if="
        type === '日期型' && list[index].new_parameter_time_type == '年月日'
      "
    >
      <el-date-picker
        v-model="list[index].new_parameter_value"
        type="date"
        size="mini"
        :disabled="isDisabled"
        value-format="yyyy-MM-dd"
        placeholder="选择日期"
        style="width: 100%"
        :picker-options="pickerOptions"
      >
      </el-date-picker>
    </template>
    <!--  -->
    <template
      v-if="type === '日期型' && list[index].new_parameter_time_type == '年月'"
    >
      <el-date-picker
        value-format="yyyy-MM"
        style="width: 100%"
        size="mini"
        :disabled="isDisabled"
        v-model="list[index].new_parameter_value"
        type="month"
        :picker-options="pickerOptions"
        placeholder="选择月"
      >
      </el-date-picker>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    type: String,
    list: Array,
    index: Number,
    listItem: Object,
    isDisabled: Boolean,
  },
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            },
          },
          {
            text: "昨天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", date);
            },
          },
          {
            text: "一周前",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            },
          },
        ],
      },
    };
  },
  created() {
    // console.log("type--->", this.type);
    // console.log("list--->", this.list);
    // console.log("index--->", this.index);
  },
  methods: {},
};
</script>

<style scoped>
.inputItem {
  width: 50%;
}
</style>
